import * as React from 'react';
import { useMsal } from "@azure/msal-react";
import { LanguageContext } from './LanguageContext';
import { useNavigate } from "react-router-dom";
import { LocalMenu } from './LocalMenu';
import { MarkdownPage } from "./MarkdownPage";
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

export const TermsView = (props) => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const context = React.useContext(LanguageContext);
    const page = "/terms/index.md"

    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
        navigate(-1);
    };

    return (
        <div style={{ display: "block", width: "100%" }}>
            <LocalMenu
                title={""}
                menuItems={false}
                selectedId={false}
                onSelectChange={false}
                onSearchClicked={false}
                pca={instance}
            />
            <div>
                <Dialog
                    open={open}
                    scroll="body"
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent>
                        <MarkdownPage page={page} pca={instance} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" style={{ color: "#fff" }} onClick={handleClose}>
                            {context.dictionary.Terms.Close}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}
